import { NgClass, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, ChangeDetectorRef, SimpleChanges, input, output, inject } from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  CommonService,
  NotificationService,
  TimeconversionService,
  ToastMessageService,
} from '@fitness-force/api';
import {
  AutomationEventType,
  CampaignSource,
  OwnershipLevel,
  Roles,
  SendNotificationTo,
  StaffStatus,
  Status,
  WhatsAppSendType,
} from '@fitness-force/enum';
import { ErrorMsgComponent } from '@fitness-force/errors';;
import type { Actions, AutomationActionPayload, AutomationMaster, CampaignActionsGroup, CampaignRequest, ClientById, REPORTSTOREINTERFACE, ReportDataForCampaign, Reports, STAFFINTERFACE, ScheduleActionPayload, SourceDataExtractionRules, WhatsAppSenderConfigurationMasterResponse, WhatsAppTemplateMaster, WhatsAppTemplateMasterResponse, WhatsappActionPayload } from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CampaignService } from '@fitness-force/api';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';

import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';

import { BehaviorSubject, Observable, catchError, distinctUntilChanged, forkJoin, map, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AutomationScheduleTypeComponent } from '@fitness-force/shared';
import { AvatarModule } from 'primeng/avatar';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { Store } from '@ngrx/store';
import { STAFF_STATE } from '@fitness-force/state';
import { FeatureFlagService } from '@fitness-force/shared-utils';
import { SkeletonModule } from 'primeng/skeleton';
import { CORPORATE_CONFIG_DETAILS } from '@fitness-force/constants';
@Component({
  selector: 'send-whatsapp',
  templateUrl: './send-whatsapp.component.html',
  styleUrls: ['./send-whatsapp.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ToggleSwitchModule,
    InputTextModule,
    DatePickerModule,
    SelectModule,
    EditorModule,
    ButtonModule,
    FileUploadModule,
    ErrorMsgComponent,
    AutomationScheduleTypeComponent,
    AvatarModule,
    CheckboxModule,
    MultiSelectModule,
    SkeletonModule,
    TranslateModule,
    NgClass,
    SlicePipe
]
})
export class SendWhatsappComponent implements OnInit, OnDestroy {
  private notificationService = inject(NotificationService);
  private fb = inject(FormBuilder);
  private toastMessageService = inject(ToastMessageService);
  private timeService = inject(TimeconversionService);
  private campaignsService = inject(CampaignService);
  private cd = inject(ChangeDetectorRef);
  private translateService = inject(TranslateService);
  private store = inject(Store);
  private commonService = inject(CommonService);
  private featureFlagService = inject(FeatureFlagService);

  readonly showPopup = input(false, { alias: "visible" });
  readonly assignedToStaffId = input(0, { alias: "staffId" });
  readonly tenantId = input(0);
  readonly franchiseId = input(0);
  readonly totalRecords = input(new BehaviorSubject<number>(0));
  readonly whatsAppSendType = input<WhatsAppSendType>(WhatsAppSendType.FreeForm, { alias: "WhatsAppSendType" });
  readonly columnData = input(new BehaviorSubject<any>([] as [
]));
  readonly CampaignSource = input<CampaignSource>(CampaignSource.Clients);
  readonly ReportDataForCampaign = input(new BehaviorSubject<ReportDataForCampaign>({} as ReportDataForCampaign));
  readonly selectedAllData = input(new BehaviorSubject<boolean>(false));
  readonly SelectedClient = input(new BehaviorSubject<ClientById>({} as ClientById));
  readonly actionPayload = input(new BehaviorSubject<WhatsappActionPayload>({} as WhatsappActionPayload));
  readonly automationMaster = input(new BehaviorSubject<AutomationMaster>({} as AutomationMaster));
  readonly formGroup = input<any>(new BehaviorSubject<any>(null));
  readonly uuid = input<string>("");
  readonly notificationTo = input<SendNotificationTo>(SendNotificationTo.Client);
  readonly ownership = input<OwnershipLevel>(OwnershipLevel.Tenant);
  readonly mode = input<string>("create");
  readonly scheduleInMin = input<number>(0);
  readonly closeSendSmsPopup = output<any>({ alias: 'closeSendSmsPopup' });
  readonly HidePopup = output<{
    closePopup: boolean;
    data: any | null;
    form: UntypedFormGroup | null;
    uuid: string;
    notificationTo: SendNotificationTo;
}>({ alias: 'hide' });

  whatsAppFrom: WhatsAppSenderConfigurationMasterResponse[] = [];
  private allWhatsAppSenderConfigs: WhatsAppSenderConfigurationMasterResponse[] = [];
  private allWhatsAppTemplates: WhatsAppTemplateMasterResponse[] = [];
  whatsappTemplateMasters$ = new BehaviorSubject<WhatsAppTemplateMasterResponse[]>([] as WhatsAppTemplateMasterResponse[]);
  whatsappTemplateMaster$ = new BehaviorSubject<WhatsAppTemplateMaster | null>({} as WhatsAppTemplateMaster);
  sendWhatsAppForm: UntypedFormGroup = new UntypedFormGroup({});
  selectedReport: REPORTSTOREINTERFACE = {} as REPORTSTOREINTERFACE;
  bodyreadOnly: boolean = false;
  btnLoading: boolean = false;
  accessedStaffs:STAFFINTERFACE[] =[];
  showCampaign = new BehaviorSubject<boolean>(false);
  showScheduleType = new BehaviorSubject<boolean>(false);
  loading = true;
  private destroy$ = new Subject<void>();
  CorporateConfigDetails = CORPORATE_CONFIG_DETAILS;


  constructor() {
    this.sendWhatsAppForm = this.fb.group({
      is_visible: [false, [Validators.required]],
      campaign_name: ['', []],
      campaign_action_date: [new Date(), []],
      campaign_description: ['', []],
      whatsapp_from: ['', [Validators.required]],
      source_date_extraction_rules: [],
      body: ['', [Validators.required]],
      whatsapp_template: ['', []],
      is_marketing_message: ['', []],
      automation_timings_type : [''],
      automation_schedule_type : [''],
      automation_timing : [''],
      notify_record_associated_staff:[''],
      notify_additional_staff_to:[]
    });

    if (this.whatsAppSendType() == WhatsAppSendType.Bulk) {
      this.sendWhatsAppForm.controls['whatsapp_template'].addValidators(
        Validators.required
      );
    } else {
      this.sendWhatsAppForm.controls['whatsapp_template'].removeValidators(
        Validators.required
      );
    }
  }

  ngOnInit(): void {
    this.store.select(STAFF_STATE).subscribe((staffs: any) => {
      this.accessedStaffs = staffs.staffList.filter((s: STAFFINTERFACE) => 
      (s.role !== Roles.FFAdmin && s.role.toString() !== Roles[Roles.FFAdmin]) &&
      (s.status === StaffStatus.Active || s.status.toString() === StaffStatus[StaffStatus.Active])
    );
    });
    
    // Check feature flag using getFlag$ for proper initialization
    this.featureFlagService.getFlag$('show_campaign')
      .pipe(takeUntil(this.destroy$))
      .subscribe(isEnabled => {
        this.showCampaign.next(isEnabled);
        this.cd.detectChanges();
      });
    
    this.componentInit();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  componentInit() {
    let forkArray: Observable<any>[] = [];
    const ownership = this.ownership();
    switch (ownership) {
      case OwnershipLevel.Company:
        forkArray = [
          this.notificationService.getWhatsappTemplatesByOwnership(ownership, 0, 0),
          this.notificationService.ListWhatsAppSenderConfigByOwnership(ownership, 0, 0)
        ];
        break;
    
      case OwnershipLevel.Franchise:
        forkArray = [
          this.notificationService.getWhatsappTemplatesByOwnership(ownership, 0, this.franchiseId()),
          this.notificationService.ListWhatsAppSenderConfigByOwnership(ownership, 0, this.franchiseId())
        ];
        break;
    
      case OwnershipLevel.Tenant:
        forkArray = [
          this.notificationService.getWhatsappTemplatesByOwnership(ownership, this.tenantId(), 0),
          this.notificationService.ListWhatsAppSenderConfigByOwnership(ownership, this.tenantId(), 0)
        ];
        break;
      default:
        forkArray = [
          this.notificationService.getWhatsappTemplatesByOwnership(ownership, this.tenantId(), 0),
          this.notificationService.ListWhatsAppSenderConfigByOwnership(ownership, this.tenantId(), 0)
        ];
        break;
    }
    
    forkJoin(forkArray).pipe(
      map(([whatsappTemplatesRes, whatsappSenderConfigRes]) => {
        const whatsappTemplates = whatsappTemplatesRes.items as WhatsAppTemplateMasterResponse[] || [];
        const whatsappSenderConfig = whatsappSenderConfigRes.items as WhatsAppSenderConfigurationMasterResponse[] || [];
        const actionPayload = this.actionPayload()?.value;
        const selectedConfigId = actionPayload?.whatsapp_sender_config_id;
        const selectedTemplateUuid = actionPayload?.whatsapp_template_master_uuid;

        this.allWhatsAppSenderConfigs = whatsappSenderConfig;
        this.allWhatsAppTemplates = this.filterTemplatesByEventType(
          whatsappTemplates.filter(o => o.event_type !== null)
        );

        const selectableSenderConfigs = this.buildSelectableSenderConfigs(selectedConfigId);
        const selectableTemplates = this.buildSelectableTemplates(selectedTemplateUuid);

        selectableTemplates.forEach(o => {
          o.not_approved = o.approval_status.toLowerCase() !== 'approved';
        });

        this.whatsappTemplateMasters$.next(selectableTemplates);
        selectableSenderConfigs.forEach(o => {
          o.isCorporate = this.CorporateConfigDetails['WhatsApp'].includes(o.display_phonenumber);
        });
        this.whatsAppFrom = selectableSenderConfigs;

        const defaultSender = selectableSenderConfigs.find(o => o.isCorporate === false);
        if (defaultSender) {
          this.SelectedWhatsAppFromFormControl.setValue(defaultSender);
        }

        if (actionPayload) {
          this.setInitData();
        } else {
          this.showScheduleType.next(true);
        }
        this.loading = false;
        this.cd.detectChanges();
      }),
      catchError(error => {
        this.whatsappTemplateMasters$.next([]);
        this.whatsAppFrom = [];
        this.loading = false;
        this.cd.detectChanges();
        return [];
      })
    ).subscribe();
    this.valueChangeFunction();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle changes to the selectedOption input
    if (changes['formGroup'] && changes['formGroup'].currentValue != null && changes['formGroup'].currentValue.value != null && changes['formGroup'].currentValue != changes['formGroup'].previousValue)
    {
      this.sendWhatsAppForm = changes['formGroup'].currentValue.value as UntypedFormGroup;
      this.sendWhatsAppForm.updateValueAndValidity();
    }
  }
  
  setInitData() {
    const actionPayload = this.actionPayload();
    if (
      actionPayload.value &&
      actionPayload.value.whatsapp_sender_config_id > 0
    ) {
      const selectedSenderConfig = this.getSelectableSenderConfig(
        actionPayload.value.whatsapp_sender_config_id
      );
      if (selectedSenderConfig) {
        this.SelectedWhatsAppFromFormControl.setValue(selectedSenderConfig);
      }
    }
    if (
      actionPayload.value &&
      actionPayload.value.whatsapp_template_master_uuid &&
      actionPayload.value.whatsapp_template_master_uuid !=''
    ) {
      const selectedTemplate = this.getSelectableTemplate(
        actionPayload.value.whatsapp_template_master_uuid
      );
      if (selectedTemplate) {
        this.SelectedWhatsAppTemplateFormControl.setValue(selectedTemplate);
        this.SelectWhatsAppTemplate();
      }
    } else {
      this.BodyFormControl.setValue(actionPayload.value ? actionPayload.value.message : "");
    }
    const mode = this.mode();
    if(mode && mode =='update')
      {
       let scheduleType = this.scheduleInMin() > 0 ? 'After' : this.scheduleInMin() < 0 ?  'Before' : 'Immediate';
       let SelectedAutomationTimingType =  this.commonService.formatScheduleTime(this.scheduleInMin(),this.automationMaster().value.automation_type.toString());
       this.SelectedAutomationScheduleTypeFormControl.setValue({key:SelectedAutomationTimingType.key,value:SelectedAutomationTimingType.key});
       this.SelectedAutomationTimingTypeFormControl.setValue(scheduleType);
       this.sendWhatsAppForm.controls['automation_timing'].setValue({key:SelectedAutomationTimingType.name,value:SelectedAutomationTimingType.value});
       this.sendWhatsAppForm.updateValueAndValidity();
       this.cd.detectChanges();
      };
      this.showScheduleType.next(true);
  }

  valueChangeFunction() {
    this.IsVisibleFormControl.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((value: any) => {
        if (value) {
          this.CampaignNameFormControl.setValidators([Validators.required]);
          this.CampaignDescriptionFormControl.setValidators([Validators.required]);
          this.CampaignActionDateFormControl.setValidators([Validators.required]);
          this.CampaignNameFormControl.updateValueAndValidity();
          this.CampaignDescriptionFormControl.updateValueAndValidity();
          this.CampaignActionDateFormControl.updateValueAndValidity();
        } else {
          this.CampaignNameFormControl.removeValidators([Validators.required]);
          this.CampaignDescriptionFormControl.removeValidators([Validators.required]);
          this.CampaignActionDateFormControl.removeValidators([Validators.required]);
          this.CampaignNameFormControl.updateValueAndValidity();
          this.CampaignDescriptionFormControl.updateValueAndValidity();
          this.CampaignActionDateFormControl.updateValueAndValidity();
        }
        this.sendWhatsAppForm.updateValueAndValidity();
        this.cd.detectChanges();
      });

    this.SelectedWhatsAppTemplateFormControl.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((value: any) => {
        if (value) {
          this.BodyFormControl.disable();
          this.bodyreadOnly = true;
        } else {
          this.BodyFormControl.enable();
          this.bodyreadOnly = false;
        }
        this.sendWhatsAppForm.updateValueAndValidity();
        this.cd.detectChanges();
      });
  }

  SelectWhatsAppTemplate() {
    let service:any;
    const ownership = this.ownership();
    switch (ownership) {
      case OwnershipLevel.Company:
      service = this.notificationService.GetWhatsAppTemplateMasterByOwnership(ownership,this.SelectedWhatsAppTemplateFormControl.value.id,0,0);
        break;
      case OwnershipLevel.Franchise:
        service = this.notificationService.GetWhatsAppTemplateMasterByOwnership(ownership,this.SelectedWhatsAppTemplateFormControl.value.id,this.franchiseId(),0);
        break;
      case OwnershipLevel.Tenant:
        service = this.notificationService.GetWhatsAppTemplateMasterByOwnership(ownership,this.SelectedWhatsAppTemplateFormControl.value.id,0,this.tenantId());
        break;
      default:
        break;
    }

    service.subscribe({
        next: (res:WhatsAppTemplateMaster) => {
          this.whatsappTemplateMaster$.next(res);
          this.BodyFormControl.setValue(res.content);
        },
        error: (error:any) => {
          this.whatsappTemplateMaster$.next(null);
          this.BodyFormControl.setValue(null);
        },
      });
  }

  getClientMobileNos() {
    const whatsAppSendType = this.whatsAppSendType();
    if (whatsAppSendType == WhatsAppSendType.Bulk) {
      let data = this.columnData().getValue();
      data = data.filter(
        (o: { clt_mobile_country_code: string; clt_mobile_no: string }) =>
          o.clt_mobile_country_code !== '0' && o.clt_mobile_no !== '0'
      );
      let uniqueData = data.map(
        (o: any) => o.clt_mobile_country_code + ' ' + o.clt_mobile_no
      );
      return uniqueData.filter(
        (value: any, index: any, self: string | any[]) =>
          self.indexOf(value) === index
      );
    } else if (whatsAppSendType == WhatsAppSendType.FreeForm) {
      return [
        this.SelectedClient().value.mobile_country_code +
          ' ' +
          this.SelectedClient().value.mobile_number,
      ];
    } else {
      return null;
    }
  }

  getClientIds(): any {
    const whatsAppSendType = this.whatsAppSendType();
    if (whatsAppSendType == WhatsAppSendType.Bulk)
      return this.filterUniqueNumbers(
        this.columnData().getValue().map((o: any) => parseInt(o.clt_id))
      );
    else if (whatsAppSendType == WhatsAppSendType.FreeForm) {
      return [this.SelectedClient().value.id];
    } else null;
  }

  SaveData() {
    if (this.sendWhatsAppForm.valid) {
      this.btnLoading = true;
      let whatsappActionPayload: WhatsappActionPayload =
        {} as WhatsappActionPayload;
      if (this.SelectedWhatsAppTemplateFormControl.value) {
        whatsappActionPayload.whatsapp_template_master_uuid =
          this.SelectedWhatsAppTemplateFormControl.value.uuid;
        whatsappActionPayload.whatsapp_sender_config_id =
          this.SelectedWhatsAppFromFormControl.value.id;
        whatsappActionPayload.message = this.BodyFormControl.value;
      } else {
        whatsappActionPayload.whatsapp_template_master_uuid = null;
        whatsappActionPayload.whatsapp_sender_config_id =
          this.SelectedWhatsAppFromFormControl.value.id;
        whatsappActionPayload.message = this.BodyFormControl.value;
      }
      console.log(whatsappActionPayload);

      if(this.whatsAppSendType() == WhatsAppSendType.Automation)
      {
        let actions : Actions= {} as Actions;
        let data :ScheduleActionPayload = {
          schedule_in_min: 0,
          actions: actions,
          action_name: "",
          associated_staff: false,
          staff_ids:[],
          description:""
        };
        data.schedule_in_min= this.SelectedAutomationTimingFormControl.value ?  this.SelectedAutomationTimingFormControl.value.value :0;
        data.action_name = this.SelectedAutomationTimingFormControl.value ?  this.SelectedAutomationTimingFormControl.value.key :  this.SelectedAutomationTimingTypeFormControl.value;
        data.associated_staff = this.SelectedAssociatedStaffFormControl && this.SelectedAssociatedStaffFormControl.value ? this.SelectedAssociatedStaffFormControl.value  : false ;
        data.staff_ids = this.SelectedAdditionalStaffFormControl && this.SelectedAdditionalStaffFormControl.value ? this.SelectedAdditionalStaffFormControl.value.map((staff: any) => staff.id) : [];
        data.actions.email_action_payload = null;
        data.actions.sms_action_payload = null;
        data.actions.whatsapp_action_payload = whatsappActionPayload;
        data.actions.task_action_payload = null;
        data.description = whatsappActionPayload.message;
        this.closeSendSmsPopup.emit(true);
        this.HidePopup.emit({closePopup:true, data:data,form:this.sendWhatsAppForm, uuid:this.uuid(),notificationTo: this.notificationTo()});
      }
      else{
        this.closeSendSmsPopup.emit(true);
        this.HidePopup.emit({closePopup:true, data:whatsappActionPayload,form:this.sendWhatsAppForm, uuid:this.uuid(),notificationTo: this.notificationTo()});
      }
    } else {
      Object.keys(this.sendWhatsAppForm.controls).forEach((field) => {
        const control = this.sendWhatsAppForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      const firstElementWithError: Element | null =
        document.querySelector('.ng-invalid');
      if (firstElementWithError)
        firstElementWithError.scrollIntoView({ behavior: 'smooth' });
      this.btnLoading = false;
      this.cd.detectChanges();
    }
  }

  SendWhatsApp() {
    if (this.sendWhatsAppForm.valid) {
      this.btnLoading = true;
      if (this.whatsAppSendType() == WhatsAppSendType.Bulk) {
        let payloadRequest: CampaignRequest[] = [] as CampaignRequest[];
        let payload: CampaignRequest = {} as CampaignRequest;
        const formValues = this.sendWhatsAppForm.value;
        payload.campaign_name = formValues['campaign_name'];
        payload.campaign_isvisble = formValues['is_visible'];
        payload.campaign_description = formValues['campaign_description'];
        payload.tenant_id = this.tenantId();
        payload.campaign_ownership = OwnershipLevel.Tenant;
        payload.campaign_franchise = 0;
        payload.actions_group = {} as CampaignActionsGroup;
        let actionGroups: CampaignActionsGroup = {} as CampaignActionsGroup;
        // actionGroups.campaign_action_date = payload.campaign_isvisble
        //   ? this.timeService.ConvertLocalDateTimeToUTC(
        //       formValues['campaign_action_date']
        //     )
        //   : this.getTomorrowDate();
        actionGroups.campaign_action_date = payload.campaign_isvisble ? this.timeService.ConvertLocalDateTimeToUTC(formValues["campaign_action_date"]) :  new Date().toISOString();
        actionGroups.source_data_type = this.CampaignSource();
        let sourceDataExtractionRules: SourceDataExtractionRules =
          {} as SourceDataExtractionRules;
        const CampaignSourceValue = this.CampaignSource();
        if (CampaignSourceValue == CampaignSource.Clients) {
          sourceDataExtractionRules.clients = this.getClientIds();
          sourceDataExtractionRules.reports = null;
          sourceDataExtractionRules.rule = null;
          sourceDataExtractionRules.jsonrule= null;
        } else if (CampaignSourceValue == CampaignSource.Report) {
          let reports: Reports = {} as Reports;
          let selectedReportData = this.ReportDataForCampaign().value;
          reports.payload = selectedReportData.rpt_fltr_payload;
          reports.relative_date =
            selectedReportData.rpt_fltr_relative_date_range;
          reports.report_key = selectedReportData.report_key;
          sourceDataExtractionRules.reports = reports;
          sourceDataExtractionRules.clients = null;
          sourceDataExtractionRules.rule = null;
          sourceDataExtractionRules.jsonrule= null;
        } else {
          sourceDataExtractionRules.clients = null;
          sourceDataExtractionRules.reports = null;
          sourceDataExtractionRules.rule = null;
          sourceDataExtractionRules.jsonrule= null;
        }
        actionGroups.source_data_extraction_rules = sourceDataExtractionRules;
        actionGroups.action_payload = [] as AutomationActionPayload[];
        let actionPayloads: AutomationActionPayload = {
          actions: {
            client_email_action_payload: null,
            client_sms_action_payload: null,
            client_whatsapp_action_payload: null,
            staff_email_action_payload: null,
            staff_sms_action_payload: null,
            staff_whatsapp_action_payload: null,
            staff_task_action_payload: null,
            client_pushnotification_action_payload: null,
            staff_pushnotification_action_payload: null,
            notification_staff: null
          },
          schedule_in_min: 0
        };
        actionPayloads.actions.staff_sms_action_payload= null;
        actionPayloads.actions.client_sms_action_payload= null;
        actionPayloads.actions.staff_email_action_payload= null;
        actionPayloads.actions.client_email_action_payload= null;
        actionPayloads.actions.staff_task_action_payload= null;
        let whatsAppActionPayload: WhatsappActionPayload = {} as WhatsappActionPayload;
        if (this.SelectedWhatsAppTemplateFormControl.value) {
          whatsAppActionPayload.whatsapp_template_master_uuid =
            this.SelectedWhatsAppTemplateFormControl.value.uuid;
          whatsAppActionPayload.whatsapp_sender_config_id =
            this.SelectedWhatsAppFromFormControl.value.id;
          whatsAppActionPayload.message = this.BodyFormControl.value;
        } else {
          whatsAppActionPayload.whatsapp_template_master_uuid = null;
          whatsAppActionPayload.whatsapp_sender_config_id =
            this.SelectedWhatsAppFromFormControl.value.id;
          whatsAppActionPayload.message = this.BodyFormControl.value;
        }
        actionPayloads.actions.client_whatsapp_action_payload = whatsAppActionPayload;
        actionPayloads.actions.staff_whatsapp_action_payload = null;
        actionGroups.action_payload.push(actionPayloads);
        payload.actions_group = actionGroups;
        payloadRequest.push(payload);
        this.campaignsService
          .CreateCampaigns(payloadRequest)
          .subscribe({
            next: (res) => {
              this.translateService
                .get('SEND_WHATSAPP.MSG.WHATSAPP_SEND')
                .subscribe((translation) => {
                  this.toastMessageService.showSuccess(translation);
                });
              this.btnLoading = false;
              this.cd.detectChanges();
              this.closePopupUp();
            },
            error: (error) => {
              this.toastMessageService.showError(error);
              this.btnLoading = false;
              this.cd.detectChanges();
            },
          });
      } else {
        let freeFormPayload:any;
        let templatePayload:any;
        let service:any;
        if(this.SelectedWhatsAppTemplateFormControl.value){
          templatePayload= {
            whatsapp_template_master_uuid:this.SelectedWhatsAppTemplateFormControl.value.uuid,
            message:this.BodyFormControl.value,
            whatsapp_sender_config_id:  this.SelectedWhatsAppFromFormControl.value.id
          };
          service =  this.notificationService.SendTemplatedWhatsAppMessage(this.tenantId(),this.getClientIds(),templatePayload);
        }
        else{
          freeFormPayload = {
            to_phone_number:this.SelectedClient().value.mobile_country_code + this.SelectedClient().value.mobile_number,
            content: this.BodyFormControl.value,
            is_marketing_message: this.sendWhatsAppForm.controls['is_marketing_message'].value || false,
          };
          service =  this.notificationService.SendWhatsAppMessage(this.tenantId(),this.SelectedClient().value.id,freeFormPayload);
        }
        
        service.subscribe({
            next: (res: any) => {
              this.translateService
                .get('SEND_WHATSAPP.MSG.WHATSAPP_SEND')
                .subscribe((translation) => {
                  this.toastMessageService.showSuccess(translation);
                });
              this.btnLoading = false;
              this.closePopupUp();
              this.cd.detectChanges();
            },
            error: (error: any) => {
              if(error.originalError.error &&  Array.isArray(error.originalError.error) && error.originalError.error.length>0)
                {
                  error.originalError.error.forEach((element: any) => {
                    if(element.success)
                      {
                        this.translateService.get('SEND_WHATSAPP.MSG.WHATSAPP_SEND')
                        .subscribe((translation) => {
                          this.toastMessageService.showSuccess(translation);
                        });
                      }
                      else
                      {
                        this.toastMessageService.showErrorMessage(element.error.errorMessage || element.errorMessage);
                      }
                  });
                }
                else{
                  this.toastMessageService.showError(error);
                  this.btnLoading = false;
                  this.cd.detectChanges();
                }
            },
          });
      }
    } else {
      Object.keys(this.sendWhatsAppForm.controls).forEach((field) => {
        const control = this.sendWhatsAppForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      const firstElementWithError: Element | null =
        document.querySelector('.ng-invalid');
      if (firstElementWithError)
        firstElementWithError.scrollIntoView({ behavior: 'smooth' });
      this.btnLoading = false;
      this.cd.detectChanges();
    }
  }

  getTomorrowDate(): string {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const tomorrowDate = tomorrow.toISOString();
    return tomorrowDate;
  }

  filterUniqueNumbers(array: number[]): number[] {
    // Return unique numbers (deduplicate array)
    return Array.from(new Set(array));
  }

  closePopupUp() {
    this.closeSendSmsPopup.emit(true);
    this.HidePopup.emit({ closePopup: true, data: this.actionPayload().value,form:this.sendWhatsAppForm,uuid:this.uuid(),notificationTo: this.notificationTo() });
  }

  Updatevalue(event: any) {
    this.cd.detectChanges();
  }

  ngAfterViewInit() {
    this.removeQlImage();
  }

  removeQlImage() {
    const imgButton = document.getElementsByClassName('ql-image');
    for (let i = 0; i < imgButton.length; i++) {
      imgButton[i].remove();
    }

    const cleanButton = document.getElementsByClassName('ql-clean');
    for (let i = 0; i < cleanButton.length; i++) {
      cleanButton[i].remove();
    }

    const codeBlock = document.getElementsByClassName('ql-code-block');
    for (let i = 0; i < codeBlock.length; i++) {
      codeBlock[i].remove();
    }
    const linkButton = document.getElementsByClassName('ql-link');
    for (let i = 0; i < linkButton.length; i++) {
      linkButton[i].remove();
    }
  }

  public get isFormValid() {
    return this.sendWhatsAppForm.valid;
  }

  get IsVisibleFormControl(): UntypedFormControl {
    return this.sendWhatsAppForm.controls['is_visible'] as UntypedFormControl;
  }

  get CampaignNameFormControl(): UntypedFormControl {
    return this.sendWhatsAppForm.controls[
      'campaign_name'
    ] as UntypedFormControl;
  }

  get CampaignDescriptionFormControl(): UntypedFormControl {
    return this.sendWhatsAppForm.controls[
      'campaign_description'
    ] as UntypedFormControl;
  }

  get CampaignActionDateFormControl(): UntypedFormControl {
    return this.sendWhatsAppForm.controls[
      'campaign_action_date'
    ] as UntypedFormControl;
  }

  get BodyFormControl(): UntypedFormControl {
    return this.sendWhatsAppForm.controls['body'] as UntypedFormControl;
  }

  get SelectedWhatsAppTemplateFormControl(): UntypedFormControl {
    return this.sendWhatsAppForm.controls[
      'whatsapp_template'
    ] as UntypedFormControl;
  }

  get SelectedWhatsAppFromFormControl() {
    return this.sendWhatsAppForm.controls[
      'whatsapp_from'
    ] as UntypedFormControl;
  }

  get SelectedAutomationTimingTypeFormControl()
  {
    return this.sendWhatsAppForm.controls['automation_timings_type'] as UntypedFormControl;
  }

  get SelectedAutomationTimingFormControl()
  {
    return this.sendWhatsAppForm.controls['automation_timing'] as UntypedFormControl;
  }

  get SelectedAutomationScheduleTypeFormControl()
  {
    return this.sendWhatsAppForm.controls['automation_schedule_type'] as UntypedFormControl;
  }

  get SelectedAdditionalStaffFormControl()
  {
    return this.sendWhatsAppForm.controls['notify_additional_staff_to'] as UntypedFormControl;
  }

  get SelectedAssociatedStaffFormControl()
  {
    return this.sendWhatsAppForm.controls['notify_record_associated_staff'] as UntypedFormControl;
  }

  public get GetWhatsAppSendType() {
    return WhatsAppSendType;
  }

  public get SendNotificationTo()
  {
    return SendNotificationTo;
  }

  private isStatusActive(status: Status | string | number): boolean {
    if (status === Status.Active || status === Status.Active.toString()) {
      return true;
    }
    const statusText = status?.toString().toLowerCase();
    return statusText === Status[Status.Active].toLowerCase() || statusText === 'active';
  }

  private filterTemplatesByEventType(
    templates: WhatsAppTemplateMasterResponse[]
  ): WhatsAppTemplateMasterResponse[] {
    const whatsAppSendType = this.whatsAppSendType();
    if (whatsAppSendType === WhatsAppSendType.Automation) {
      const automationMaster = this.automationMaster();
      return templates.filter(o =>
        o.event_type === automationMaster.value.automation_type ||
        o.event_type.toString() === AutomationEventType[automationMaster.value.automation_type]
      );
    }
    if (
      whatsAppSendType === WhatsAppSendType.Campaign ||
      whatsAppSendType === WhatsAppSendType.FreeForm
    ) {
      return templates.filter(o =>
        o.event_type === AutomationEventType.Campaign ||
        o.event_type.toString() === AutomationEventType[AutomationEventType.Campaign]
      );
    }
    return templates;
  }

  private buildSelectableSenderConfigs(
    selectedConfigId?: number
  ): WhatsAppSenderConfigurationMasterResponse[] {
    return this.allWhatsAppSenderConfigs.filter(config =>
      this.isStatusActive(config.status) || config.id === selectedConfigId
    );
  }

  private buildSelectableTemplates(
    selectedTemplateUuid?: string | null
  ): WhatsAppTemplateMasterResponse[] {
    return this.allWhatsAppTemplates.filter(template =>
      this.isStatusActive(template.status) || template.uuid === selectedTemplateUuid
    );
  }

  private getSelectableSenderConfig(
    configId: number
  ): WhatsAppSenderConfigurationMasterResponse | undefined {
    let selectedConfig = this.whatsAppFrom.find(o => o.id === configId);
    if (selectedConfig) {
      return selectedConfig;
    }

    selectedConfig = this.allWhatsAppSenderConfigs.find(o => o.id === configId);
    if (!selectedConfig) {
      return undefined;
    }

    this.whatsAppFrom = [...this.whatsAppFrom, selectedConfig];
    this.cd.markForCheck();
    return selectedConfig;
  }

  private getSelectableTemplate(
    templateUuid: string
  ): WhatsAppTemplateMasterResponse | undefined {
    let selectedTemplate = this.whatsappTemplateMasters$.value.find(o => o.uuid === templateUuid);
    if (selectedTemplate) {
      return selectedTemplate;
    }

    selectedTemplate = this.allWhatsAppTemplates.find(o => o.uuid === templateUuid);
    if (!selectedTemplate) {
      return undefined;
    }

    selectedTemplate.not_approved = selectedTemplate.approval_status.toLowerCase() !== 'approved';
    const templates = [...this.whatsappTemplateMasters$.value, selectedTemplate];
    this.whatsappTemplateMasters$.next(templates);
    this.cd.markForCheck();
    return selectedTemplate;
  }

}